var React = require('react');

function NavigationArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.5 8H2.5","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7 3.5L2.5 8L7 12.5","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

NavigationArrow.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = NavigationArrow;

NavigationArrow.default = NavigationArrow;
